import { getEntityById, getAllEntitiesByBot, getAllEntity, getAllSynonyms, addEntity, addSynonyms, addContent, updateEntity, updateContent, deleteContent, deleteEntity} from '@/api/entities.service.js'
import { getBotById } from '@/api/bot.service.js'

export default {
  state:{
    entity: {},
    entities: [],
    childrens: [],
    synonyms: []
  },
  getters:{
    getAllEntities(state){
      return state.entities
    },
    getEntity(state){
      return state.entity
    },
    getChildren(state){
      return state.childrens
    },
    getSynonyms(state){
      return state.synonyms
    }
  },
  mutations:{
    setAllEntities(state, entities){
      state.entities = entities
    },
    setEntityById(state, entity){
      state.entity = entity
    },
    addEntity(state, newEntity){
      state.entity = newEntity
      state.entities.splice(0,0,newEntity)
    },
    updateEntity(state, newEntity){
      // state.entity = newEntity
     
     state.entities = newEntity
    },
    addSynonyms(state, entity){
      state.entity = entity
    },
    setContent(state, child){
      state.entity.children = child
    },
    addContent(state, children){
      state.entity.children = children
    },
    setChildrens(state, chld){
      state.entity.children.splice(0,0, chld)
    },
    setSynonyms(state, synonyms){
      state.synonyms = synonyms
    },
    setAllEnts(state, entities){
      state.entities = entities
    },
    setAllEntDash(state, entities){
      state.entities = entities
    }
  },
  actions:{
    async setAllEnts(context,id){
      let entities = await getAllEntitiesByBot(id)
     
      let infoEntities = new Array
    
      if(typeof entities != undefined && entities != null && entities.length && entities.length > 0){
      	entities.forEach(el => {
        getEntityById(el._id).then((data) => {
          infoEntities.splice(0,0,data)
        })
      });
        }     
      context.commit('setAllEnts', infoEntities)
    },
    async setAllEntDash(context,id){
      let entities = await getAllEntitiesByBot(id)
      context.commit('setAllEntDash', entities)
    },
    async setAllEntities(context){
      let entities = await getAllEntity()
      context.commit('setAllEntities', entities)
    },
    async setAllEntityByBot(context, idBot){
      let listEntities = await getAllEntitiesByBot(idBot)
      context.commit('setAllEntities', listEntities)
    },
    async setEntityById(context, id){
      let entity = await getEntityById(id)
      context.commit('setEntityById', entity)
    },
    
    async addEntity(context, entity) {
      let bot = await getBotById(entity.bot._id)
      entity.bot.name = bot.name
      let newentity = await addEntity(entity)
      context.commit('addEntity', newentity)
    },

 
    async addSynonyms(context, entity){
      let entityS = await addSynonyms(entity)
      context.commit('addSynonyms', entityS)
    },
    async addContent(context, entity){
     console.log("########## store add content",entity)
      let entityC = await addContent(entity)
      console.log("######### store entityC",entityC)
      context.commit('addContent', entityC[0].children)
    },
    setChildrens(context, chld){
      context.commit('setChildrens', chld)
    },
    async deleteEntity(context, id){
      let newEntities = await deleteEntity(id)
      context.commit('setAllEntities', newEntities)
    },
    async updateEntity(context, entity){
      let upEntity = await updateEntity(entity)
      context.commit('updateEntity', upEntity)
    },
    async setSynonyms(context, idBot){
      let listSynonyms = await getAllSynonyms(idBot)
      console.log("########### listSynonyms ##########", listSynonyms)
      context.commit('setSynonyms', listSynonyms)
    },
    async deleteContent(context, content){
      let childs = await deleteContent(content)
      context.commit('setContent', childs.children)
    },
    async updateContent(context, child){
      let childs = await updateContent(child)
      context.commit('setContent', childs)
    } 
  }
}


// WEBPACK FOOTER //
// ./src/store/entities.store.js